import React, { useEffect } from 'react'
import styled from 'styled-components';
import device from '../../theme/MediaQueries';
import confetti from 'canvas-confetti';

const RelativeDiv = styled.div`
  position: relative;
  text-align: center;

	& h1 {
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
		text-fill-color: transparent;
		font-size: 14rem;
		line-height: 1;

		background-color: #ff5acd;
		background-image: linear-gradient(
			55deg,
			#fbda61,
			#ff5acd,
			#00ddff,
			#ff22e9,
			#ffae00,
			#22ffe2
		);

		@media ${device.MXlg} {
			font-size: 10rem;
			text-align: left;
		}
		@media ${device.MXmd} {
			font-size: 7rem;
			text-align: left;
		}
		@media ${device.MXsm} {
			font-size: 5rem;
			text-align: left;
		}
		@media ${device.MXxs} {
			font-size: 5rem;
			text-align: center;
		}
	}

	.pre-title {
		font-weight: 700;
		font-size: 8rem;
		line-height: 1;
		@media ${device.MXmd} {
			font-size: 5rem;
			text-align: left;
		}
		@media ${device.MXsm} {
			font-size: 4rem;
			text-align: left;
		}
		@media ${device.MXxs} {
			font-size: 2.8rem;
			text-align: center;
		}
	}

	img {
		max-width: 100%;
		width: 100%;
	}

	.title-wrap h1,
	.title-wrap h2 {
		margin: 0;
		width: 100%;
	}



  & .fluf-wrap {
    position: relative;
    width: 100%;
    height: 100%;

    & img {
      position: absolute;
      left: 0;
      height: 100%;
      width: 100%;
      object-fit: cover;

      @media ${device.MXsm} {
        position: relative;
      }
    }
  }

  & .grad-after {
    overflow: hidden;
    overflow: hidden;
    max-height: calc(100vh - 150px);
    min-height: 70vh;
    align-content: stretch;

    @media ${device.MXsm} {
      min-height: 40vh;
      max-height: none;
    }
    @media ${device.MXmd} {
      min-height: 55vh;
      max-height: none;
    }
    @media ${device.MXmd} and (orientation: landscape) {
      min-height: 95vh;
    }
    &:before,
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 150px;
      z-index: 1;
      background-image: linear-gradient(#1a1a1a00 10%, #1a1a1a 100%);
    }
    &:before {
      content: '';
      bottom: auto;
      top: 0;
      background-image: linear-gradient(#1a1a1a 10%, #1a1a1a00 100%);

      @media ${device.MXsm} {
        display: none;
      }
    }
	}

`;

export default function Birthday({flufImage}) {

	useEffect(() => {
		const colors = ['#fbda61', '#ff5acd'];
		const colors2 = ['#1cb2d0', '#0eec06'];
		const colors3 = ['#d01c1c', '#fcf301'];
		const colors4 = ['#1f1cd0', '#fc9301'];

		setTimeout(() => {
			confetti({
				particleCount: 1200,
				angle: 45,
				spread: 360,
				origin: { x: 0, y: -0.5 },
				startVelocity: 90,
				colors,
				disableForReducedMotion: true,
			});
			setTimeout(() => {
				confetti({
					particleCount: 1200,
					angle: -90,
					spread: 360,
					origin: { x: 0.5, y: -0.5 },
					startVelocity: 90,
					colors2,
					disableForReducedMotion: true,
				});
			}, 400);
			setTimeout(() => {
				confetti({
					particleCount: 1200,
					angle: 90,
					spread: 360,
					origin: { x: 0.5, y: 1 },
					startVelocity: 90,
					colors4,
					disableForReducedMotion: true,
				});
			}, 600);
			setTimeout(() => {
				confetti({
					particleCount: 1200,
					angle: -45,
					spread: 360,
					origin: { x: 1, y: -0.5 },
					startVelocity: 90,
					colors3,
					disableForReducedMotion: true,
				});
			}, 200);
		}, 1000);
	}, []);
  
  return (
    <RelativeDiv className="relative">
      <div className="grid--2 grid--s-1 align-items--center grad-after">
        <div className="title-wrap">
          <h1 className="text--left">Happy Birthday</h1>
          <div className="text--left pre-title">Fluf World</div>
        </div>
        <div className="fluf-wrap">
          <img
            src={flufImage}
            className="fluf-image"
            alt="Happy Birthday Fluf World"
          />
        </div>
      </div>
    </RelativeDiv>
  )
}
